export enum DocumentStatus {
  PROCESSING = 'processing',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  FAILED = 'failed',
}

export class Document {
  id!: string;
  version_id!: string;
  catalog_id!: string;
  name!: string;
  url!: string;
  extension!: string;
  status!: DocumentStatus;
  content_size_bytes!: number;
  versions?: Document[];
  markdown_content?: string;
  created_at!: string;
  updated_at!: string;
  updated_by!: string;

  constructor(document: Partial<Document | null>) {
    this.id = '';
    this.version_id = '';
    this.catalog_id = '';
    this.name = '';
    this.url = '';
    this.extension = '';
    this.status = DocumentStatus.PROCESSING;
    this.content_size_bytes = 0;
    this.versions = [];
    this.markdown_content = '';
    this.created_at = '';
    this.updated_at = '';
    this.updated_by = '';
    Object.assign(this, document);
  }
}

export interface PreProcessConfig {
    file: File;
    optimization: boolean;
    indexing: boolean;
    contextualization: boolean;
}
